function useSelectControlValue(data, definition) {
  return data ?? definition?.config.defaultValue;
}
export {
  useSelectControlValue
};
//# sourceMappingURL=select.js.map